module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner-1bf2667ffde730c44f05b097d1c3b440.jpg";